/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { Box, Flex } from 'chakra-v3';

export interface ChatMessageProps {
  /** Whether this message is from the platform (left) or user (right) */
  isPlatform: boolean;
  /** The content to render inside the message bubble */
  children: React.ReactNode;
}

/**
 * Chat message wrapper component that positions messages on left (platform) or center (user)
 * Platform components are left-aligned, user components are centered and highlighted
 * Both platform and user components handle their own styling
 */
export const ChatMessage: React.FC<ChatMessageProps> = ({ isPlatform, children }) => {
  if (isPlatform) {
    // Platform components: left-aligned
    return (
      <Flex w="100%" justify="flex-start" px={{ base: '16px', md: '24px' }} py="12px">
        <Box maxW="75%" w="100%" display="flex" flexDirection="column" alignItems="flex-start">
          {children}
        </Box>
      </Flex>
    );
  }

  // User components: centered and highlighted
  return (
    <Flex w="100%" justify="center" px={{ base: '16px', md: '24px' }} py="12px" position="relative" zIndex={1}>
      <Box w="100%" maxW="100%" display="flex" flexDirection="column" alignItems="center">
        {children}
      </Box>
    </Flex>
  );
};
